import React from "react";
import { App } from "./app";
import "./style/base.css";

import { createRoot } from "react-dom/client";
const root = createRoot(document.getElementById("root"));
root.render(<App />);
